import { AppThunk } from 'app/store'
import { parseError } from 'utils/errors'
import * as api from 'services/laneProposal'
import { slice } from './reducer'
import { updateRFPDetailLaneProposal } from 'features/requestForProposalList/actions'

export const {
  fetchLaneProposalsStart,
  fetchLaneProposalsSuccess,
  fetchLaneProposalsFailed,
  updateLaneProposalStart,
  updateLaneProposalSuccess,
  updateLaneProposalFailed,
} = slice.actions

export const fetchLaneProposals = (lane: number): AppThunk => async (
  dispatch
) => {
  dispatch(fetchLaneProposalsStart())
  try {
    const data = await api.list(lane)
    dispatch(fetchLaneProposalsSuccess(data))
  } catch (err) {
    dispatch(fetchLaneProposalsFailed())
  }
}

export const partialUpdateLaneProposal = (
  laneId: number,
  proposalId: number,
  payload: Partial<LaneProposal>
): AppThunk => async (dispatch) => {
  dispatch(updateLaneProposalStart(proposalId))
  try {
    const data = await api.partialUpdate(laneId, proposalId, payload)
    dispatch(updateLaneProposalSuccess(data))
  } catch (err) {
    const error = parseError(err)
    dispatch(updateLaneProposalFailed({ error, id: proposalId }))
  }
}

export const partialUpdateProposal = (
  laneId: number,
  proposalId: number,
  partialProposal: Partial<LaneProposal>
): AppThunk => async (dispatch, getState) => {
  const state = getState()
  const proposal = state.laneProposals.proposals[proposalId]

  dispatch(updateLaneProposalStart(proposalId))

  try {
    const data = await api.partialUpdate(laneId, proposal.id, partialProposal)
    dispatch(updateLaneProposalSuccess(data))
    dispatch(updateRFPDetailLaneProposal({ laneId, proposal: data }))
  } catch (err) {
    const error = parseError(err)
    dispatch(updateLaneProposalFailed({ error, id: proposal.id }))
  }
}
